import { Validator, VARIABLE_VALIDATION_REGEX } from './Validator';
import { ValidationError } from './ValidatorError';
const VALIDATE_GUID_REGEX = /^[a-f\d]{8}(-[a-f\d]{4}){4}[a-f\d]{8}$/i;
export class ExecuteBlipFunctionActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.source) {
            throw new ValidationError('The blip function source is required');
        }
        if (model.inputVariables) {
            model.inputVariables.forEach(inputVariable => {
                if (!inputVariable.match(VARIABLE_VALIDATION_REGEX)) {
                    throw new ValidationError('The blip function input variable name should be composed only by letters, numbers and dots');
                }
            });
        }
        if (!model.outputVariable) {
            throw new ValidationError('The blip function output variable is required');
        }
        if (!model.outputVariable.match(VARIABLE_VALIDATION_REGEX)) {
            throw new ValidationError('The blip function output variable name should be composed only by letters, numbers and dots');
        }
        if (!model.source.match(VALIDATE_GUID_REGEX)) {
            throw new ValidationError('The blip function output variable name should be composed only by letters, numbers and dots');
        }
    }
}
